import React from 'react';
import { Row, Col, Button, Tooltip, Input, Select, Spin, Icon, Table, Modal } from 'antd';
import { openNotification } from '../../util/notificaciones';

import CatalogosRequest from '../../services/Catalogos';
import UsuarioNotificacionRequest from '../../services/UsuarioNotificaciones';

import FormNotificaciones from './FormNotificaciones';
import ResponsiveCard from '../Common/ResponsiveCard';
import BaseComponent from '../Common/BaseComponent';

const { Option } = Select;
const { confirm } = Modal;
/**
 * Clase para ver el proceso de mostrar las notificaciones
 */
export default class Notificaciones extends BaseComponent {
    state = {
        cargando: false,
        filterText: "",
        arrPlazas: [],
        plazaSelected: null,
        paginacion: {},
        modalUsuarioNotificaciones: false,
        filtros: {
            nombre: undefined,
            plaza: undefined,
            page: undefined
        },
        arrUsuarioNotificaciones: [],
        arrUsuarioNotificacionesCopy: [],
        usrNotificacionSelected: null,
        disableDeleteFilters: true
    }


    /**
     * Comportamiento del componente al mostrar los artículos
     */
    componentDidMount() {
        this.cargarNotificaciones();
    }

    /**
     * Función que se ejecuta para cargar las notificaciónes
     */
    cargarNotificaciones = () => {
        let state = { ...this.state }

        if (state.filterText.trim() === "" && state.plazaSelected === null ) {
            state.disableDeleteFilters = true
        } else {
            state.disableDeleteFilters = false
        }

        this.setState({ cargando: true }, () => {
            CatalogosRequest.ListarPlazas()
                .then(plazaResp => {
                    state.arrPlazas = plazaResp.data;

                    return UsuarioNotificacionRequest.ListarUsuarioNotificaciones(state.filtros)
                })
                .then(usuarioNotificacionResp => {
                    state.arrUsuarioNotificaciones = usuarioNotificacionResp.data;
                    state.arrUsuarioNotificacionesCopy = usuarioNotificacionResp.data;
                    state.cargando = false;
                    this.setState(state);
                })
                .catch(err => {
                    this.setState({ cargando: false });
                    openNotification(
                        "Ha ocurrido un error al listar las notificaciones.",
                        "Error al listar las notificaciones",
                        false
                    )
                });
        });
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        let buscar = false;

        if (value.trim() !== state.filterText.trim()) buscar = true
        state.filterText = value;
        state.filtros.nombre = value.trim() === "" ? undefined : value.trim()
        this.setState(state);
        if (buscar) {
            clearTimeout(state.timer)
            state.timer = setTimeout(() => {
                this.filtrarBack();
            }, 1000);
        }
    }

    /**
     * Función para asignar la plaza al combo
     * @param: value. opción seleccionada
     * @return: nada
     */
    onChangePlaza = (value) => {
        let state = { ...this.state };

        state.filtros.plaza = value === undefined ? null : value;
        state.plazaSelected = value === undefined ? null : value;
        this.setState(state, this.filtrarBack)
    }

    /**
     * Función para limpiar todos los filtros que han
     * sido manipulados por el usuario.
     * @param: nada
     * @return: nada
     */
    cleanFilters = () => {
        let state = { ...this.state }

        state.disableDeleteFilters = true;
        state.filtros.plaza = undefined;
        state.filtros.nombre = undefined;
        state.filterText = "";
        state.arrPlazas = [];
        state.plazaSelected = null;
        state.modalUsuarioNotificaciones = false;
        state.arrUsuarioNotificaciones = [];
        state.arrUsuarioNotificacionesCopy = [];
        state.usrNotificacionSelected = null;
        
        this.setState(state, this.filtrarBack);
        openNotification("Los filtros se han limpiado correctamente.", "Filtros limpiados correctamente", true);
    }

    /**
     * Función para mostar el modal para agregar un usuario para que le
     * llegue las notificaciones
     * @param: nada
     * @return: nada
     */
    showModal = () => {
        this.setState({ modalUsuarioNotificaciones: true })
    }

    /**
     * Función para esconder modal para agregar un usuario para que le 
     * llegue las notificaciones
     * @param: value. true o false
     * @return: nada
     */
    esconderModal = (value) => {
        let state = { ...this.state };
        state.modalUsuarioNotificaciones = false;
        state.usrNotificacionSelected = null;
        this.setState(state);
        
        if(value) this.cargarNotificaciones()
    }

    /**
     * Función para mostrar la confirmación para eliminar 
     * la notificación.
     * @param: nada.
     * @return: nada.
     */
    showConfirmDelete = () => {
        confirm({
            title: 'Confirmar',
            content: <div><b>¿Está seguro de eliminar la notificación?</b> Se borrará la notificación definitivamente.</div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            okButtonProps: {
                id: 'boton-aceptar-confirmacion-eliminar-notificacion-form',
            },
            cancelButtonProps: {
                id: 'boton-cancelar-confirmacion-eliminar-notificacion-form',
            },
            onOk: () => {
                this.setState({ cargando: true });
                UsuarioNotificacionRequest.eliminarNotificacion(this.state.usrNotificacionSelected.id)
                    .then(resp => {
                        this.setState({usrNotificacionSelected: null, cargando:false});
                        openNotification(
                            resp?.data?.cuerpo,
                            resp?.data?.titulo,
                            true
                        );
                        this.cargarNotificaciones();
                    })
                    .catch(err => {
                        this.setState({cargando: false});
                        openNotification(
                            err?.data?.cuerpo,
                            err?.data?.tiulo,
                            false
                        )
                    })
            },
        });
    }

    /**
        * Función que se encarga de hacer las peticion en el back para filtrar
    */
    filtrarBack = () => {
        let state = { ...this.state };
        
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }

        this.cargarNotificaciones();
    }

    render() {
        const columnaNotificaciones = [
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre"
            },
            {
                title: "Correo",
                dataIndex: "email",
                key: "email"
            },
            {
                title: "Tipo Notificación",
                dataIndex: "tipo_notificacion_nombre",
                key: "tipo_notificacion_nombre"
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (value, record) => (
                    <div>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Ver detalle de la notificación"}>
                                <Button
                                    icon="eye"
                                    id='boton-detalle-usuario-modulo'
                                    onClick={() =>{
                                        this.setState({
                                            usrNotificacionSelected: record,
                                            modo: 'ver'
                                        }, this.showModal())
                                    }}
                                >
                                </Button>
                            </Tooltip>
                        </span>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Editar notificación"}>
                                <Button
                                    icon="edit"
                                    id='boton-detalle-usuario-notificacion'
                                    onClick={() =>{
                                        this.setState({
                                            usrNotificacionSelected: record,
                                            modo: 'editar'
                                        }, this.showModal())
                                    }}
                                >
                                </Button>
                            </Tooltip>
                        </span>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Eliminar notificación"}>
                                <Button
                                    id='boton-eliminar-usuario-notificacion'
                                    icon="delete"
                                    className="btnEditar"
                                    onClick={() =>{
                                        this.setState({
                                            usrNotificacionSelected: record
                                            }, this.showConfirmDelete)
                                    }}
                                >
                                </Button>
                            </Tooltip>
                        </span>
                    </div>
                )
            }
        ]

        return(
            <ResponsiveCard id="ParentSize"
                title="Módulo Notificaciones"
                extra={
                    <div>
                        <Button
                            className="btnVerCrearGuardar"
                            type="primary"
                            id="boton-agregar-usuario"
                            onClick={() => {
                                this.setState({ modo: 'nuevo', tipo_modal: 'dos' }, () => {
                                    this.showModal();
                                })

                            }}
                        >
                            Agregar Usuario
                        </Button>
                    </div>
                }
            >
                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={12}>
                            <Col span={8}>
                                <div className="center">Búsqueda:</div>
                                <Tooltip
                                    placement="top"
                                    title="Buscar usuario">
                                    <Input
                                        autoFocus={true}
                                        maxLength={70}
                                        id="input-buscar-usuarios-modulo"
                                        placeholder="Buscar por Nombre / Correo"
                                        onChange={(e) => this.filterText(e.currentTarget.value)}
                                        value={this.state.filterText}
                                    />
                                </Tooltip>
                            </Col>
                            <Col span={8}>
                                <Tooltip placement="top" title="Buscar usuarios por plaza">
                                    <div className="center">Plaza:</div>
                                    <Select
                                        allowClear={true}
                                        style={{ width: '100%' }}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        defaultValue={null}
                                        showSearch
                                        id="select-filtros-plaza-usuarios"
                                        defaultActiveFirstOption={false}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        value={this.state.plazaSelected}
                                        onChange={this.onChangePlaza}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrPlazas.length > 0 &&
                                            this.state.arrPlazas.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={this.state.isPos ? 3 : 2}>
                                <div className="center-down">
                                    <Tooltip placement="top" title="Borrar filtros">
                                        <Button 
                                            id="boton-borrar-filtros-usuarios" 
                                            type="default" 
                                            icon="delete" 
                                            className={this.state.disableDeleteFilters ? 'disableBtn' : ''} 
                                            style={{ width: '100%', marginBottom: "30px", marginTop: '1.3em' }} 
                                            onClick={this.cleanFilters}
                                        >
                                        </Button>
                                    </Tooltip>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                    >
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={usuarioNotificacion => usuarioNotificacion.id}
                            columns={columnaNotificaciones}
                            dataSource={this.state.arrUsuarioNotificacionesCopy}
                            pagination={this.state.paginacion}
                        />
                    </Spin>
                </div>
                <FormNotificaciones
                    esconderModal={this.esconderModal}
                    modo={this.state.modo}
                    visible={this.state.modalUsuarioNotificaciones}
                    usrNotificacion_selected={this.state.usrNotificacionSelected}
                >

                </FormNotificaciones>
            </ResponsiveCard>
        )
    }
}